module.exports = __webpack_public_path__ + "img/2024-07-01b_1.114906e8.jpg";